"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {assetPath} from "@/shared/utils/asset-path";

interface GuestsButtonProps {
    totalGuests: number;
    totalPets: number;
    isOpen: boolean;
    onClick: () => void;
}

export function GuestsButton({totalGuests, totalPets, isOpen, onClick}: GuestsButtonProps): JSX.Element {
    const {t} = useTranslation("search");

    const guestsText = t("guestsCount", {count: totalGuests});
    const petsText = t("dogsCount", {count: totalPets});

    return (
        <div className="guests-view__trigger-wrapper">
            <button type="button" onClick={onClick} className="guests-view__trigger input-field__wrapper">
                <div className="guests-view__content">
                    <SmartImage
                        src={assetPath("/images/icons/property/people.svg")}
                        alt={guestsText}
                        width={16}
                        height={16}
                        className={`guests-view__icon`}
                    />
                    <span className="guests-view__text">{guestsText}</span>
                    {totalPets > 0 && (
                        <>
                            <SmartImage
                                src={assetPath("/images/icons/property/pet.svg")}
                                alt={petsText}
                                width={17}
                                height={17}
                                className={`guests-view__icon--pets`}
                            />
                            <span className="guests-view__text">{petsText}</span>
                        </>
                    )}
                </div>
                <SmartImage
                    src={assetPath("/images/icons/chevron-down.svg")}
                    alt="Toggle"
                    width={16}
                    height={16}
                    className={`guests-view__chevron ${isOpen ? "guests-view__chevron--open" : ""}`}
                />
            </button>
        </div>
    );
}
